import httpService from "./httpService";
import axios from "../baseURL";

export const saveUserProgress = async (userDataObj) => {
  try {
    const userProgressData = {
      userName: userDataObj.name,
      emailId: userDataObj.emailId,
      ...(userDataObj.progress !== undefined && {
        progress: userDataObj.progress,
      }),
      ...(userDataObj.totalScore !== undefined && {
        totalScore: userDataObj.totalScore,
      }),
      ...(userDataObj.totalScore !== undefined && {
        totalScore: userDataObj.totalScore,
      }),
      ...(userDataObj.redeemedScores !== undefined && {
        redeemedScores: Array.from(userDataObj.redeemedScores),
      }),
      ...(userDataObj.finishedTasks !== undefined && {
        finishedTasks: Array.from(userDataObj.finishedTasks),
      }),
      ...(userDataObj.gameFinished !== undefined && {
        gameFinished: userDataObj.gameFinished,
      }),

      // redeemedScores: userDataObj.redeemedScores
      //   ? Array.from(userDataObj.redeemedScores)
      //   : [],
      // finishedTasks: userDataObj.finishedTasks
      //   ? Array.from(userDataObj.finishedTasks)
      //   : [],
    };
    const response = await httpService.post(axios.baseURL, userProgressData);
    return response.data;
  } catch (error) {
    console.error("Error saving user progress:", error);
    return null;
  }
};
